(function () {
    "use strict";

    angular.module("cardspotWeb")
        .config(configHttpProvider);

    configHttpProvider.$inject = ["$httpProvider"];

    function configHttpProvider($httpProvider) {
        $httpProvider.interceptors.push("jwtInterceptor");
        $httpProvider.interceptors.push("globalHttpInterceptor");
    }
}());